import axios from 'axios';
import type {
  LockboxSearchForMLSStaffResponse,
  SearchForESLockboxQuery,
} from '@bb/domain/dist/types';

const getMLSLockboxes = async <T = LockboxSearchForMLSStaffResponse>(
  queryOptions?: SearchForESLockboxQuery,
) => {
  const { data } = await axios.get<T>(`/lockbox_mls`, {
    params: queryOptions,
  });

  return data;
};

export default getMLSLockboxes;
